export var TurnType;
(function (TurnType) {
    TurnType[TurnType["Clockwise"] = 0] = "Clockwise";
    TurnType[TurnType["CounterClockwise"] = 1] = "CounterClockwise";
    TurnType[TurnType["Double"] = 2] = "Double";
})(TurnType || (TurnType = {}));
